import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Paragraph, Box } from '@zillow/constellation';
import { useLastValidCashOutRefinanceValues, FieldConfig } from './CashOutRefinanceCalculator.utils.js';
import { commaSeparateNumber, getCommaSeparatedNumber } from '../../utils/zhl-calculator.js';
import TextField from '../Fields/TextField.js';
import SelectField from '../Fields/SelectField.js';
import CheckboxField from '../Fields/CheckboxField.js';
import LegalPopover from '../CalculatorForm/LegalPopover.js';

var CashOutRefinanceFields = function CashOutRefinanceFields() {
  var form = useFormContext();
  var lastValidCashOutRefinanceValues = useLastValidCashOutRefinanceValues();
  var _lastValidCashOutRefi = lastValidCashOutRefinanceValues.fields,
    homeValue = _lastValidCashOutRefi.homeValue,
    currentMortgageBalance = _lastValidCashOutRefi.currentMortgageBalance;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextField, {
    label: "Home value",
    leftAdornment: "$",
    name: FieldConfig.homeValue.name,
    config: FieldConfig.homeValue.config,
    textButtonName: "See Zestimate",
    textButtonHref: '/how-much-is-my-home-worth/',
    autoComplete: "off",
    format: commaSeparateNumber,
    onChange: function onChange() {
      form.setValue(FieldConfig.adjustCashOutAmount.name, getCommaSeparatedNumber(form.getValues(FieldConfig.homeValue.name) * 80 / 100 - currentMortgageBalance));
    },
    required: true
  }), /*#__PURE__*/React.createElement(TextField, {
    label: "Current mortgage balance",
    leftAdornment: "$",
    name: FieldConfig.currentMortgageBalance.name,
    config: FieldConfig.currentMortgageBalance.config,
    autoComplete: "off",
    format: commaSeparateNumber,
    tooltip: {
      title: 'Current mortgage balance',
      body: /*#__PURE__*/React.createElement(Paragraph, null, "Enter the remaining balance of your current loan.")
    },
    onChange: function onChange() {
      form.setValue(FieldConfig.adjustCashOutAmount.name, getCommaSeparatedNumber(homeValue * 80 / 100 - form.getValues(FieldConfig.currentMortgageBalance.name)));
    },
    required: true
  }), /*#__PURE__*/React.createElement(SelectField, {
    options: FieldConfig.newLoanTerm.options,
    label: "New loan term",
    name: FieldConfig.newLoanTerm.name,
    config: FieldConfig.newLoanTerm.config,
    required: true,
    tooltip: {
      title: 'New loan term',
      body: /*#__PURE__*/React.createElement(Paragraph, null, "Your new term is the number of months set for you to pay off your new loan, which replaces your existing mortgage during refinancing. The new term may or may not be the same as your current term. To convert your new term from years to months, multiply the number of years by 12. For instance, a 30-year mortgage term is equal to 360 months.")
    }
  }), /*#__PURE__*/React.createElement(TextField, {
    label: "New interest rate",
    rightAdornment: "%",
    name: FieldConfig.newInterestRate.name,
    config: FieldConfig.newInterestRate.config,
    autoComplete: "off",
    tooltip: {
      title: 'New interest rate',
      body: /*#__PURE__*/React.createElement(Paragraph, null, "The default interest rate is based upon a national, or state specific average from lenders quoting on Zillow for preliminary research purposes only. Actual available rates and monthly payment amounts are subject to market fluctuations and will depend on a number of factors, including geography and loan characteristics. You may enter a different refi interest rate in this field.")
    },
    required: true
  }), /*#__PURE__*/React.createElement(TextField, {
    label: "Adjust cash-out amount",
    leftAdornment: "$",
    name: FieldConfig.adjustCashOutAmount.name,
    config: FieldConfig.adjustCashOutAmount.config,
    autoComplete: "off",
    format: commaSeparateNumber,
    tooltip: {
      title: 'Adjust cash-out amount',
      body: /*#__PURE__*/React.createElement(Paragraph, null, "You can take out less than the max cash-out amount. Reduce the dollar amount to see your adjusted LTV, loan balance and payment amount.")
    },
    required: true
  }), /*#__PURE__*/React.createElement(TextField, {
    label: "Refinance fees",
    leftAdornment: "$",
    name: FieldConfig.fees.name,
    config: FieldConfig.fees.config,
    autoComplete: "off",
    format: commaSeparateNumber,
    tooltip: {
      title: 'Refinance fees',
      body: /*#__PURE__*/React.createElement(Paragraph, null, "Like all home loans, a refinance loan requires closing costs to pay for things like the loan origination fee, title and appraisal. You can roll the fees into the new loan by checking the box.")
    }
  }), /*#__PURE__*/React.createElement(CheckboxField, {
    label: "Roll fees into new loan",
    name: FieldConfig.rollFees.name,
    tooltip: {
      title: 'Roll fees into new loan',
      body: /*#__PURE__*/React.createElement(Paragraph, null, "If you want to avoid any upfront costs of refinancing, you can include those costs as part of your new loan amount to be paid as part of your future mortgage payments. See how those costs will affect your savings.")
    }
  }), /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      justifyContent: 'flex-start'
    }
  }, /*#__PURE__*/React.createElement(LegalPopover, {
    triggerText: "Calculator disclaimer",
    text: "The refinance calculator is intended to be used for educational purposes only. Savings are not guaranteed; savings are dependent upon your current loan terms, credit profile, and available lender loan terms. Actual available rates and monthly payment amounts are subject to market fluctuations and will depend on a number of factors, including geography and loan characteristics. The estimates are based on information you provide, and does not include other fees and costs that a lender may assess in addition to monthly principal and interest, such as taxes and insurance and the actual payment obligation may be greater. Zillow Group Marketplace, Inc. does not make loans and this is not a commitment to lend."
  })));
};
var CashOutRefinanceFields$1 = CashOutRefinanceFields;

export { CashOutRefinanceFields$1 as default };
